import React from "react";
import CheckCircle from "../../../assets/svgs/CheckCircle";
import RemoveCircle from "../../../assets/svgs/RemoveCircle";
import Upload from "../../../assets/svgs/Upload";

function Tr({ country, period, invoice, received, duedata, daysdue, amount }) {
  return (
    <tr className="border-b">
      <td className="px-2 py-5 whitespace-nowrap text-sm text-gray-900">
        {country}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm text-gray-900">
        {period}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm text-gray-900">
        {invoice}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm text-gray-900">
        {received}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm text-gray-900">
        {duedata}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm text-gray-900">
        {daysdue}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm text-gray-900">
        {amount}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-sm text-gray-900">
        <div className="flex justify-center">
          <button className="text-red-500">
            <RemoveCircle />
          </button>
          <button className="text-green-500">
            <CheckCircle />
          </button>
        </div>
      </td>

      <td className="px-2 py-5 whitespace-nowrap text-sm text-gray-900">
        <button className="transform rotate-180">
          <Upload />
        </button>
      </td>
    </tr>
  );
}

const Table = () => {
  return (
    <div className="flex flex-col">
      <div className="overflow-x-auto">
        <div className="py-2 inline-block min-w-full">
          <div className="overflow-hidden">
            <table className="min-w-full border text-center">
              <thead className="border-b">
                <tr>
                  <th className="text-sm text-gray-900 px-2 py-5">Country</th>
                  <th className="text-sm text-gray-900 px-2 py-5">Perion</th>
                  <th className="text-sm text-gray-900 px-2 py-5">
                    Invoice n*
                  </th>
                  <th className="text-sm text-gray-900 px-2 py-5">Received</th>
                  <th className="text-sm text-gray-900 px-2 py-5">Due Date</th>
                  <th className="text-sm text-gray-900 px-2 py-5">Days Due</th>
                  <th className="text-sm text-gray-900 px-2 py-5">Amount</th>
                  <th className="text-sm text-gray-900 px-2 py-5">Pay Now</th>
                </tr>
              </thead>
              <tbody>
                <Tr
                  country="United States"
                  period="15 - 13 April"
                  invoice="1423"
                  received="13/10/22"
                  duedata="13/10/22"
                  daysdue="3"
                  amount="€4,200,00"
                />
                <Tr
                  country="United States"
                  period="15 - 13 April"
                  invoice="1423"
                  received="13/10/22"
                  duedata="13/10/22"
                  daysdue="3"
                  amount="€4,200,00"
                />
                <Tr
                  country="United States"
                  period="15 - 13 April"
                  invoice="1423"
                  received="13/10/22"
                  duedata="13/10/22"
                  daysdue="3"
                  amount="€4,200,00"
                />
                <Tr
                  country="United States"
                  period="15 - 13 April"
                  invoice="1423"
                  received="13/10/22"
                  duedata="13/10/22"
                  daysdue="3"
                  amount="€4,200,00"
                />
                <Tr
                  country="United States"
                  period="15 - 13 April"
                  invoice="1423"
                  received="13/10/22"
                  duedata="13/10/22"
                  daysdue="3"
                  amount="€4,200,00"
                />
                <Tr
                  country="United States"
                  period="15 - 13 April"
                  invoice="1423"
                  received="13/10/22"
                  duedata="13/10/22"
                  daysdue="3"
                  amount="€4,200,00"
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table;
